import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { FlashMessagesService } from 'angular2-flash-messages';
import { LoginService } from '../login.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-selectport',
  templateUrl: './selectport.component.html',
  styleUrls: ['./selectport.component.css']
})
export class SelectportComponent implements OnInit {
  hide: any = '';
  hides: any = '';
  pro: any = {};
  proDatas: any = [];
  currentUser: any = {};
  currentOrg: any = {};
  privacy: any;
  dataResult: any;
  show: number = 0;
  ReadingClub: any;
  module_access: any;
  showPrivacyPopup: boolean = false;

  constructor(private appComponent: AppComponent, private _common: CommonService, private _flashMessagesService: FlashMessagesService, private router: Router, private loginservice: LoginService) { }

  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }

    // Ensure it's parsed (if still a string from API)
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);

    // Find module access object
    const mod = accessArray.find(m => m.module_id == module_id);

    // Return true if found (you can also check for specific rights)
    return !!mod;
  }
  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    this.loginservice.deletePastCheckouts(this.currentUser.salon_id).subscribe(data => { }, error => { alert('Network Error deletePastCheckouts API'); });
    const today = new Date();
    const day = today.getDate();  // Get the current day of the month
    this.ReadingClub = 'http://www.kalloscaresm.com/ReadingClub/#/'
    // Check if the current day is 1, 2, 15, or 17
    if ([1, 2, 15, 16, 11].includes(day)) {
      // setTimeout(() => { alert('Please Check Inventory Stock') }, 500);
    }
    this.getScheduler();
    this.updateMembership();
    this.appComponent.ngOnInit();
    this.getWhatsAppTemplate();

    // Show privacy policy popup every time user logs in
    this.showPrivacyPopup = true;
  }

  closeReminder() {
    this.show = 0;
  }

  updateMembership() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');  // Month is 0-based, so add 1
    const day = today.getDate().toString().padStart(2, '0');  // Add leading zero to day if needed
    const hours = today.getHours().toString().padStart(2, '0');  // Add leading zero if needed
    const minutes = today.getMinutes().toString().padStart(2, '0');  // Add leading zero if needed
    const seconds = today.getSeconds().toString().padStart(2, '0');  // Add leading zero if needed
    const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const currentDate = `${year}-${month}-${day}`;  // Format the current date
    this.loginservice.updateMembership(currentDateTime, currentDate, this.currentUser).subscribe((data: any) => {

    })
  }
  getScheduler() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');  // Month is 0-based, so add 1
    const day = today.getDate().toString().padStart(2, '0');  // Add leading zero to day if needed
    const hours = today.getHours().toString().padStart(2, '0');  // Add leading zero if needed
    const minutes = today.getMinutes().toString().padStart(2, '0');  // Add leading zero if needed
    const seconds = today.getSeconds().toString().padStart(2, '0');  // Add leading zero if needed
    const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    const currentDate = `${year}-${month}-${day}`;  // Format the current date
    this.loginservice.getScheduler(currentDateTime, currentDate, this.currentUser).subscribe((data: any) => {
      if (data['data'] && data['data'].length > 0) {
        this.dataResult = data['data'];
        this.show = 1;
      } else {
        this.show = 0;
        this.dataResult = [];
      }
    }, error => { alert('Network Error getScheduler API'); });
  }


  public setLoginMode(x) {
    this._common.setLocalSession('mode', x);
    if (x === 'app') {
      this.router.navigateByUrl('/emp-detail');
    } else if (x === 'Services') {
      this.router.navigateByUrl('/Serviceoffered');
    } else if (x === 'cp') {
      this.router.navigateByUrl('/cp');
    } else if (x === 'upload') {
      this.router.navigateByUrl('/upload');
    } else if (x === 'Inventory') {
      // this.router.navigateByUrl('/inventory-items');
      this.router.navigateByUrl('//inventory-manager/1');
    } else if (x === 'Customer') {
      this.router.navigateByUrl('/customer-detail');
    } else if (x === 'SchedulerList') {
      this.router.navigateByUrl('/customer-scheduler-list');
    } else if (x === 'Billing') {
      this.router.navigateByUrl('/billings');
    } else if (x === 'Combo') {
      this.router.navigateByUrl('/combo');
    } else if (x === 'invoice-report') {
      this.router.navigateByUrl('/invoice-report');
    } else if (x === 'discount-offers') {
      this.router.navigateByUrl('/discount-offers');
    } else if (x === 'incentive-setup-grid') {
      this.router.navigateByUrl('/incentive-setup-grid');
    } else if (x === 'Reading-Club-Application') {
      this.router.navigateByUrl('/Reading-Club-Application');
    } else if (x === 'list-stories') {
      this.router.navigateByUrl('/list-stories');
    } else if (x === 'Attendance') {
      this.router.navigateByUrl('/attendance-dashboard');
    } else if (x === 'manageSalons') {
      this.router.navigateByUrl('/manageSalons');
    } else if (x === 'WhatsApp') {
      this.router.navigateByUrl('/WhatsAppMsgTemplate');
    } else if (x === 'whatsAppBulk') {
      this.router.navigateByUrl('/whatsAppBulk');
    } else if (x === 'whatsapp-report') {
      this.router.navigateByUrl('/whatsapp-report');
    } else if (x === 'whatsapp-campaign-report') {
      this.router.navigateByUrl('/whatsapp-campaign-report');
    }
  }

  closePrivacyPopup() {
    this.showPrivacyPopup = false;
  }

  acceptPrivacyPolicy() {
    this.showPrivacyPopup = false;
  }

  getWhatsAppTemplate() {
    // this.loginservice.getWhatsAppTemplate('', this.currentUser)
    // this.loginservice.getWhatsAppTemplateFromMeta()
    this.loginservice.getWhatsAppStoredTemplateFromMeta(this.currentUser, '')
      .subscribe(
        data => { }, error => { alert('Network Error getWhatsAppStoredTemplateFromMeta API'); });
  }
}



// WEBPACK FOOTER //
// ./src/app/selectport/selectport.component.ts